// Thin fetch wrapper. Sends cookies (Discord session), parses JSON, normalizes errors.
// Hooks can throw `ApiError` and let TanStack Query surface it.

export class ApiError extends Error {
  constructor(message, { status, body, reason } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
    this.reason = reason; // e.g. 'jha_required'
  }
}

async function parse(res) {
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) return res.json();
  return res.text();
}

export async function api(path, { method = 'GET', body, headers, signal } = {}) {
  const opts = {
    method,
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      ...headers,
    },
    signal,
  };
  if (body !== undefined) {
    if (body instanceof FormData) {
      opts.body = body; // browser sets the boundary
    } else {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
  }
  const res = await fetch(path, opts);
  const parsed = await parse(res).catch(() => null);
  if (!res.ok) {
    const msg = (parsed && parsed.error) || res.statusText || 'Request failed';
    throw new ApiError(msg, {
      status: res.status,
      body: parsed,
      reason: parsed && parsed.reason,
    });
  }
  return parsed;
}

// Convenience verbs.
export const get    = (p, init)       => api(p, { ...init, method: 'GET' });
export const post   = (p, body, init) => api(p, { ...init, method: 'POST',   body });
export const put    = (p, body, init) => api(p, { ...init, method: 'PUT',    body });
export const del    = (p, init)       => api(p, { ...init, method: 'DELETE' });
